import { resolveOrgFromToken, useAuth } from 'library';

const useNotificationOrgId = () => {
  const { token } = useAuth();
  return token ? resolveOrgFromToken(token.accessToken) : null;
};

export default useNotificationOrgId;
